import { FeatureData } from "../types/types";
import workday from "@assets/images/logo/workDay.png";
import bamboo from "@assets/images/logo/bamboo.jpg";
import trinet from "@assets/images/logo/Trinet.png";
import google from "@assets/images/logo/google.png";
import apple from "@assets/images/logo/apple-logo.png";
import linkPay from "@assets/images/logo/linkPay.png";
import amazon from "@assets/images/logo/social.png";
import plaid from "@assets/images/logo/plaid.png";
import hrPartner from "@assets/images/logo/hr-partner.png";
import { IntlShape } from "react-intl";

export const getNewsletterOptions = (intl : IntlShape) => [
  { label: intl.formatMessage({ id: 'daily' }), isChecked: true },
  { label: intl.formatMessage({ id: 'twice.week' }), isChecked: false },
  { label: intl.formatMessage({ id: 'weekly' }), isChecked: false },
  { label: intl.formatMessage({ id: 'never' }), isChecked: false },
];

export const companyFeatures: FeatureData[] = [
  {
    iconClass: "bi bi-geo-alt",
    bgClass: "bg-success",
    title: "400,000+ Locations",
    description: "Our network of locations reaches destinations worldwide. If you need to be there, we can accommodate!"
  },
  {
    iconClass: "bi bi-gear-wide-connected",
    bgClass: "bg-primary",
    title: "Control Options",
    description: "Set rules for your team on where, when and how they can select hotels and destinations"
  },
  {
    iconClass: "bi bi-clipboard-data",
    bgClass: "bg-orange",
    title: "Stay Under Budget",
    description: "We know managing budgets can be challenging. Lean on our savings to make it easier!"
  },
  {
    iconClass: "bi bi-shield-check",
    bgClass: "bg-info",
    title: "Flexibility",
    description: "Plans change in the business world, get peace of mind by knowing we help you stay flexible."
  },
];


export const registerData = [
  "24/7 customer support",
  "Flexible options",
  "Over 400,000 hotels"
]


export const footerFeatures = [
  {
    icon: "headset",
    title: "24/7 Support",
    description: "Our support staff is standing by 24/7 to assist.",
  },
  {
    icon: "award",
    title: "Guarantee",
    description: "All refunds come with no questions asked guarantee.",
  },
];

export const creditSections = [
  {
    headerTitle: "Reports",
    rows: [
      { title: "Current Credit Total by Member", linkText: "" },
      { title: "Company Travel Credit History", linkText: "" },
      { title: "My Travel Credit History", linkText: "" },
    ],
  },
  {
    headerTitle: "More Info",
    rows: [
      { title: "Terms & Conditions", linkText: "" },
      { title: "How Credits Work", linkText: "" },
      { title: "Reallocating Travel Credits", linkText: "" },
    ],
  },
];

export const creditTransactions = [
  {
    date: "05-26-2022",
    description: "Booking: Hilton Garden Center, Orlando, FL",
    type: "Debit",
    amount: "$79.85",
    balance: "$70.15",
  },
  {
    date: "03-19-2022",
    description: "Promotion: Account sign-up bonus",
    type: "Credit",
    amount: "$150.00",
    balance: "$150.00",
  },
];
export const getCompanyInfoForm = (intl: any) => [
  {
    name: 'name',
    label: intl.formatMessage({ id: 'company.form.label.legalName' }),
    required: true,
    inputType: 'text',
    disabled: false,
    placeholder: intl.formatMessage({ id: 'company.form.placeholder.legalName' }),
    col: 6,
  },
  {
    name: 'email',
    label: intl.formatMessage({ id: 'company.form.label.email' }),
    required: true,
    inputType: 'email',
    placeholder: intl.formatMessage({ id: 'company.form.placeholder.email' }),
    col: 6,
  },
  {
    name: 'baseAddressSite',
    label: intl.formatMessage({ id: 'company.form.label.baseAddressSite' }),
    required: true,
    inputType: 'text',
    placeholder: intl.formatMessage({ id: 'company.form.placeholder.baseAddressSite' }),
    col: 6,
  },
  {
    name: 'property',
    label: intl.formatMessage({ id: 'company.form.label.property' }),
    required: true,
    inputType: 'text',
    placeholder: intl.formatMessage({ id: 'company.form.placeholder.property' }),
    col: 6,
  },
];
export const getNavItems = (intl: any, hasEnabledCreditLine: boolean) => {
  const baseNavItems = [
    { href: "company-trends", icon: "bi-columns-gap", label: intl.formatMessage({ id: "nav.overview" }) },
    { href: "company-settings", icon: "bi-building", label: intl.formatMessage({ id: "nav.companyInfo" }) },
    { href: "company-team", icon: "bi-people", label: intl.formatMessage({ id: "nav.teamMembers" }) },
    { href: "company-integrations", icon: "bi-plug", label: intl.formatMessage({ id: "nav.integrations" }) },
    { href: "company-preferences", icon: "bi-sliders2", label: intl.formatMessage({ id: "nav.preferences" }) },
    { href: "company-branding", icon: "bi-palette", label: intl.formatMessage({ id: "nav.branding" }) },
    { href: "company-travel", icon: "bi-briefcase", label: intl.formatMessage({ id: "nav.businessRules" }) },
    { href: "company-custom-fields", icon: "bi-input-cursor-text", label: intl.formatMessage({ id: "nav.customFields" }) },
    { href: "company-department", icon: "bi bi-diagram-3", label: intl.formatMessage({ id: "nav.departments" }) },
    { href: "company-account-payment", icon: "bi bi-credit-card", label: intl.formatMessage({ id: "payment.details" }) },
    { href: "company-bookings", icon: "bi bi-suitcase-lg", label: intl.formatMessage({ id: "company.bookings" }) },
  ];

  if (hasEnabledCreditLine) {
    baseNavItems.splice(7, 0, { href: "credit-line", icon: "bi-credit-card", label: intl.formatMessage({ id: "nav.billingDashboard" }) });
  }
  return baseNavItems;
};


export const menuItems = [
  { title: "Solutions", items: ["Travel Managers", "Operations Teams", "Finance Managers", "Corporate Travelers", "Corporate Groups"], id: "solutionsDropdown" },
  { title: "Features", items: ["Dashboard Control", "Reporting Tools", "Easy Invoicing", "Loyalty Rewards", "Trip Flex Pro"], id: "featuresDropdown" },
  { title: "Our Customers", items: ["Our Customers", "Testimonials", "24/7 Support", "Calculate Savings"], id: "customersDropdown" }
];

export const getMenuItems = (intl:any) => [
  {
    title: intl.formatMessage({ id: 'menu.solutions.title' }),
    items: [
      intl.formatMessage({ id: 'menu.solutions.travelManagers' }),
      intl.formatMessage({ id: 'menu.solutions.operationsTeams' }),
      intl.formatMessage({ id: 'menu.solutions.financeManagers' }),
      intl.formatMessage({ id: 'menu.solutions.corporateTravelers' }),
      intl.formatMessage({ id: 'menu.solutions.corporateGroups' })
    ],
    id: 'solutionsDropdown',
  },
  {
    title: intl.formatMessage({ id: 'menu.features.title' }),
    items: [
      intl.formatMessage({ id: 'menu.features.dashboardControl' }),
      intl.formatMessage({ id: 'menu.features.reportingTools' }),
      intl.formatMessage({ id: 'menu.features.easyInvoicing' }),
      intl.formatMessage({ id: 'menu.features.loyaltyRewards' }),
      intl.formatMessage({ id: 'menu.features.tripFlexPro' })
    ],
    id: 'featuresDropdown',
  },
  {
    title: intl.formatMessage({ id: 'menu.customers.title' }),
    items: [
      intl.formatMessage({ id: 'menu.customers.ourCustomers' }),
      intl.formatMessage({ id: 'menu.customers.testimonials' }),
      intl.formatMessage({ id: 'menu.customers.support' }),
      intl.formatMessage({ id: 'menu.customers.calculateSavings' })
    ],
    id: 'customersDropdown',
  }
];

  export const contactInfo = [
    { label: "Sales:", phone: "(828) 785-4573" },
    { label: "Member Support:", phone: "(828) 785-4573" },
  ];
  
  export const businessSolutions = [
    { id: 'footer.businessSolutions.travelManagers', href: "/travbusiness-solutions-for-travel-managers" },
    { id: 'footer.businessSolutions.operationsManagers', href: "/travbusiness-solutions-for-operations-managers" },
    { id: 'footer.businessSolutions.financeManagers', href: "/travbusiness-solutions-for-finance-managers" },
    { id: 'footer.businessSolutions.travelers', href: "/travbusiness-solutions-for-travelers-hotels-cars" },
  ];
  export const platformFeatures = [
    { id: 'footer.platformFeatures.reportingTools', href: "/travbusiness-reporting-insights" },
    { id: 'footer.platformFeatures.easyInvoicing', href: "/travbusiness-your-solution-for-easy-travel-invoices" },
    { id: 'footer.platformFeatures.loyaltyRewards', href: "/travbusiness-loyalty-rewards-benefits-for-travelers-hotel-and-car" },
  ];
  
  export const companyLinks = [
    { id: 'footer.ourCompany.aboutUs', href: "/travbusiness-about-us-history-travel" },
    { id: 'footer.ourCompany.privacyPolicy', href: "/travbusiness-privacy-policy" },
    { id: 'footer.ourCompany.termsOfUse', href: "/travbusiness-terms-of-use" },
  ];
  
  export const footerSections = [
      { title: "Business Solutions", links: businessSolutions },
      { title: "Platform Features", links: platformFeatures },
      { title: "Our Company", links: companyLinks },
  ];
  export const getFooterSections = (intl: any) => [
    {
      title: intl.formatMessage({ id: 'footer.businessSolutions' }),
      links: businessSolutions.map(link => ({
        ...link,
        title: intl.formatMessage({ id: link.id })
      })),
    },
    {
      title: intl.formatMessage({ id: 'footer.platformFeatures' }),
      links: platformFeatures.map(link => ({
        ...link,
        title: intl.formatMessage({ id: link.id })
      })),
    },
    {
      title: intl.formatMessage({ id: 'footer.ourCompany' }),
      links: companyLinks.map(link => ({
        ...link,
        title: intl.formatMessage({ id: link.id })
      })),
    },
  ];
  
  export const getContactInfo = (intl : any) => [
    { label: intl.formatMessage({ id: 'footer.contact.sales' }), phone: '(828) 785-4573' },
    { label: intl.formatMessage({ id: 'footer.contact.memberSupport' }), phone: '(828) 785-4573' },
  ];
  export const socialIcons = [
  { icon: "facebook-f", color: "facebook", link: "#" },
  { icon: "instagram", color: "instagram", link: "#" },
  { icon: "twitter", color: "twitter", link: "#" },
  { icon: "linkedin-in", color: "linkedin", link: "#" },
 ];

export const getHrItems = (intl: IntlShape) => [
  {
    href: "hr-partner",
    icon: `${hrPartner}`,
    label: intl.formatMessage({ id: "hr.partner.label" }),
    description: intl.formatMessage({ id: "hr.partner.description" }),
  },
  {
    href: "workday",
    icon: `${workday}`,
    label: intl.formatMessage({ id: "hr.workday.label" }),
    description: intl.formatMessage({ id: "hr.workday.description" }),
  },
  {
    href: "bamboohr",
    icon: `${bamboo}`,
    label: intl.formatMessage({ id: "hr.bamboo.label" }),
    description: intl.formatMessage({ id: "hr.bamboo.description" }),
  },
  {
    href: "trinet",
    icon: `${trinet}`,
    label: intl.formatMessage({ id: "hr.trinet.label" }),
    description: intl.formatMessage({ id: "hr.trinet.description" }),
  },
];

export const getPaymentItems = (intl: IntlShape) => [
  {
    href: 'ApplePay',
    icon: `${apple}`,
    label: intl.formatMessage({ id: 'payment.applepay.label' }),
    description: intl.formatMessage({ id: 'payment.applepay.description' }),
  },
  {
    href: 'GooglePay',
    icon: `${google}`,
    label: intl.formatMessage({ id: 'payment.googlepay.label' }),
    description: intl.formatMessage({ id: 'payment.googlepay.description' }),
  },
  {
    href: 'AmazonPay',
    icon: `${amazon}`,
    label: intl.formatMessage({ id: 'payment.amazonpay.label' }),
    description: intl.formatMessage({ id: 'payment.amazonpay.description' }),
  },
  {
    href: 'LinkPay',
    icon: `${linkPay}`,
    label: intl.formatMessage({ id: 'payment.linkpay.label' }),
    description: intl.formatMessage({ id: 'payment.linkpay.description' }),
  },
];
export const paymentItems = [
  {
    href: 'ApplePay', 
    icon: `${apple}`,
    label: 'ApplePay',
    description:
      'Apple Pay allows users to make secure purchases in apps and on the web using Face ID, Touch ID, or passcode authentication. It supports seamless transactions without needing to enter payment details manually.',
  },
  {
    href: 'GooglePay', 
    icon: `${google}`,
    label: 'GooglePay',
    description:
      'Google Pay enables fast, simple, and secure online and in-store transactions using saved cards. It supports tap-to-pay functionality and integrates with multiple banking and rewards programs.',
  },
  {
    href: 'AmazonPay', 
    icon: `${amazon}`,
    label: 'AmazonPay',
    description:
      'Amazon Pay allows customers to use their existing Amazon account details for checkout. It offers a fast, secure, and familiar payment experience while leveraging Amazon’s fraud protection.',
  },
  {
    href: 'LinkPay', 
    icon: `${linkPay}`,
    label: 'LinkPay', 
    description:'LinkPay enables seamless and secure payment transactions through generated payment links. This method simplifies the payment process by allowing customers to pay directly via a link, eliminating the need for complex checkout procedures. It is designed for quick and efficient payments, ideal for various scenarios like invoicing, online sales, and peer-to-peer transactions.',
  },
];

export const getAccountItems = (intl: IntlShape) => [
  {
    href: 'Plaid',
    icon: `${plaid}`,
    label: intl.formatMessage({ id: 'account.plaid.label' }),
    description: intl.formatMessage({ id: 'account.plaid.description' }),
  },
];
